import React, { Fragment, useEffect } from "react"

import { validate, styles } from "./util"

import { InputAdornment, Stack, Typography } from "@mui/material"
import { Field } from "formik"
import { formatPhone } from "../../../util/formating"

export default function TextField(props) {
	let { formik, type, name, label, placeHolder, info} = props
	let { disabled, hidden, validation, onChange, onBlur } = props

	const { values, setFieldValue, errors, touched, setTouched } = formik
	const value = (values?.[name] == null || values?.[name] == undefined) ? "" : values?.[name]
	const error = touched?.[name] && errors?.[name] ? errors?.[name] : null
	const startAdornment = <InputAdornment position="start">+1</InputAdornment>
	if (typeof label === "function") label = label({ ...formik, name, value })
	if (typeof placeHolder === "function") placeHolder = placeHolder({ ...formik, name, value })
	if (typeof info === "function") info = info({ ...formik, name, value })
	if (typeof disabled === "function") disabled = disabled({ ...formik, name, value }) 
	if (typeof hidden === "function") hidden = hidden({ ...formik, name, value }) 
	if (typeof validation === "function") validation = validation({ ...formik, name, value })

	useEffect(()=>{
		if(name== "phone" || name.toLowerCase().includes("phone"))
		{
			let pvalue = formatPhone({ phone: value })
			setFieldValue(name, pvalue)
		}
	},[])
	async function handleChangePhone(event) {
			let value = event?.target?.value
			value = value?.replace(/\D/g, "")
			const backspace = event?.nativeEvent?.inputType === "deleteContentBackward"
			if (backspace && value?.length <= 6) value = value?.slice(0, -1)
	
			const phoneRegex = /^\d{0,10}$/
			if (!phoneRegex.test(value)) return
	
			value = formatPhone({ phone: value })
			setFieldValue(name, value)

			if (onChange) {
				formik.values[name] = value
				await onChange({ ...formik, name, value })
			}
			setTouched({});
	}
	async function handleChange(event) {
		try {
			const value = event?.target?.value
			setFieldValue(name, value)
			if (onChange) {
			formik.values[name] = value
			await onChange({ ...formik, name, value });
			}
			setTouched({});
		} catch (error) {
			console.error(error);
		}
	}


	async function handleBlur(event) {
		try {
			let value = event?.target?.value

			value = value.replace(/ +(?= )/g, "")?.trim()
			setFieldValue(name, value)

			if (onBlur) {
				formik.values[name] = value
				await onBlur({ ...formik, name, value })
			}

			// setTouched({ ...touched, [name]: true })
		} catch (error) {
			console.error(error)
		}
	}

	function handleValidation(value) {
		if (typeof validation === "string") {
			if (validate.required(value)) {
				return validate.required(value)
			} else if (validation === "email" && validate.email(value)) {
				return validate.email(value)
			} else if (validation === "phone" && validate.phone(value)) {
				return validate.phone(value)
			} else if (validation !== "email" && validate.string(value)) {
				return validate.string(value)
			}
		}

		if (validation && typeof validation === "object") {
			const { error, anyChar, minValue, maxValue, minLength, maxLength, custom } = validation

			if (validate.required(value, error)) {
				return validate.required(value)
			} else if (!anyChar && validate.string(value)) {
				return validate.string(value)
			} else if (validate.minValue(value, minValue)) {
				return validate.minValue(value, minValue)
			} else if (validate.maxValue(value, maxValue)) {
				return validate.maxValue(value, maxValue)
			} else if (validate.minLength(value, minLength)) {
				return validate.minLength(value, minLength)
			} else if (validate.maxLength(value, maxLength)) {
				return validate.maxLength(value, maxLength)
			} else if (typeof custom === "function") {
				return custom({ ...formik, name, value })
			}
		}
	}

	return hidden ? (
		<Fragment />
	) : (
		<Stack spacing="5px" sx={{position:'relative',width:"100%"}}>
			<Typography sx={styles.label}>{label}</Typography>
			{false && name == "phone" && <p style={{position:'absolute',left:'6px',top:'30px'}}>+1</p> }
			<div style={{display: type=="hidden" ? "none":"block"}}>
			<Field
				sx={{paddingLeft:(name == "phone" || name.toLowerCase().includes("phone") ) ? '24px !important':'17px !important'}}
				type={(name == "phone" || name.toLowerCase().includes("phone") ) ? "text" : type}
				name={name}
				placeholder={placeHolder || label}
				value={`${value}`}
				disabled={disabled}
				validate={handleValidation}
				onChange={(name == "phone" || name.toLowerCase().includes("phone") ) ? handleChangePhone : handleChange}
				onBlur={handleBlur}
				 onKeyDown={(e) => {
					if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab" && name == "ein") {
					e.preventDefault();
					}
				}}
			/>
			</div>
			{Boolean(error) ? (
				<Typography sx={styles.error}>{error}</Typography>
			) : (
				<Typography sx={styles.info}>{info || "\u00A0"}</Typography>
			)}
		</Stack>
	)
}
